import { render, staticRenderFns } from "./EcommAbout.vue?vue&type=template&id=2882227c"
import script from "./EcommAbout.vue?vue&type=script&lang=js"
export * from "./EcommAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports